import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ChevronUpIcon } from '@heroicons/react/solid'

import useQuery from '@/hooks/useQuery'
import { useGlobalState } from '@/state'

const VoteButton = ({ slug, voted, votesCount, size = 'md', onChange }) => {
  const { putpostRequest } = useQuery()
  const [currentUser] = useGlobalState('currentUser')
  const [busy, setBusy] = useState(false)
  const [localVoted, setLocalVoted] = useState(voted)
  const [localCount, setLocalCount] = useState(votesCount)

  const handleClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (busy) return
    if (!currentUser?.id) {
      window.location.href = `/login?fwd=${encodeURIComponent('/feedback')}`
      return
    }
    setBusy(true)
    putpostRequest(`/api/v1/feedbacks/${slug}/vote`, 'POST', {}, (err, data) => {
      setBusy(false)
      if (err) return
      setLocalVoted(data.voted)
      setLocalCount(data.votesCount)
      if (onChange) onChange(data)
    })
  }

  const sizes = {
    sm: 'w-12 py-1.5 text-sm',
    md: 'w-14 py-2 text-base',
    lg: 'w-16 py-3 text-lg'
  }

  return (
    <button
      type='button'
      onClick={handleClick}
      disabled={busy}
      className={`${sizes[size]} flex flex-col items-center justify-center rounded-lg border transition-colors ${
        localVoted
          ? 'bg-clcpurple text-white border-clcpurple hover:bg-clcpurple/90'
          : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:border-clcpurple hover:text-clcpurple'
      } disabled:opacity-60`}
      aria-label={localVoted ? 'Remove vote' : 'Upvote'}
    >
      <ChevronUpIcon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} />
      <span className='font-bold leading-none mt-0.5'>{localCount}</span>
    </button>
  )
}

VoteButton.propTypes = {
  slug: PropTypes.string.isRequired,
  voted: PropTypes.bool,
  votesCount: PropTypes.number.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  onChange: PropTypes.func
}

export default VoteButton
